module.exports = __webpack_public_path__ + "img/T6-B-21.19200502.png";